import { createI18n } from 'vue-i18n';
/* import { createI18n } from "vue-i18n/dist/vue-i18n.esm-bundler.js"; */
/* 
import { useStore } from 'vuex'
import store from './store' */
/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
// Funzione per caricare i messaggi localizzati dall'applicazione
function loadLocaleMessages() {
  // Utilizza la funzione require.context() di webpack per ottenere il contesto delle directory dei file di lingua
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  // Crea un oggetto vuoto per i messaggi localizzati
  const messages = {};
  // Itera su tutti i file di lingua presenti nella directory
  locales.keys().forEach((key) => {
    // Cerca di estrarre la lingua dal nome del file utilizzando una regex
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    // Se la lingua è stata trovata, aggiungi il file dei messaggi all'oggetto messages
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  // Restituisce l'oggetto dei messaggi localizzati
  return messages;
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.locale || process.env.VUE_APP_I18N_LOCALE || 'it',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'it',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
  fallbackWarn: false,
  missingWarn: false,
});
